import React, { Component } from 'react';
import { Clock, CalendarPlus, MapPin } from 'lucide-react';
export function NextMeeting() {
  // Enlace de Google Calendar prellenado con los datos de la reunión
  const googleCalendarUrl = 'https://calendar.google.com/calendar/render?action=TEMPLATE' + '&text=' + encodeURIComponent('Reunión General Comunitaria — Sylmar NC') + '&dates=20260612T183000/20260612T203000' + '&location=' + encodeURIComponent('Sylmar Recreation Center, 13109 Borden Ave, Sylmar, CA 91342') + '&details=' + encodeURIComponent('Reunión General Comunitaria del Concilio Vecinal de Sylmar.');
  return <section id="next-meeting" className="py-24 px-6 lg:px-8 bg-white relative overflow-hidden" data-id="element-244">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-softblue rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-245"></div>
      <div className="max-w-5xl mx-auto" data-id="element-246">
        <div className="text-center mb-12" data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-248">
            Próxima Reunión
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-249">
            Participa en la próxima reunión comunitaria
          </p>
          <p className="text-gray-500 mt-2" data-id="element-250">
            Tu presencia ayuda a que las necesidades del vecindario sean
            escuchadas.
          </p>
        </div>

        <div className="bg-softblue rounded-3xl overflow-hidden shadow-xl border border-softblue-dark" data-id="element-251">
          <div className="bg-charcoal p-6 md:p-8 text-white flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-252">
            <div className="flex items-center gap-4" data-id="element-253">
              <div className="bg-warm text-charcoal p-4 rounded-2xl flex flex-col items-center justify-center min-w-[80px]" data-id="element-254">
                <span className="text-sm font-bold uppercase" data-id="element-255">JUN</span>
                <span className="text-3xl font-black leading-none" data-id="element-256">12</span>
              </div>
              <div data-id="element-257">
                <h3 className="text-2xl font-bold text-softblue" data-id="element-258">
                  Reunión General Comunitaria
                </h3>
                <p className="text-softblue-dark flex items-center gap-2 mt-1" data-id="element-259">
                  <Clock className="w-4 h-4" data-id="element-260" /> 6:30 PM
                </p>
                <p className="text-softblue-dark/80 flex items-center gap-2 mt-1 text-sm notranslate" data-id="element-261">
                  <MapPin className="w-4 h-4" data-id="element-262" /> Sylmar Recreation Center
                </p>
              </div>
            </div>
            <div className="w-full md:w-auto" data-id="element-263">
              <a href={googleCalendarUrl} target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-warm hover:bg-warm-hover text-charcoal font-bold py-3 px-6 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-264">
                <CalendarPlus className="w-5 h-5" data-id="element-265" />
                Agregar al calendario
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}